import { Key } from 'react';
import styles from './Timeline.module.scss';
import { AddendumResponse } from '../../../shared/models/AddendumModel';

interface TimelineProp {
  steps: AddendumResponse[];
}

function Timeline({ steps }: TimelineProp) {
  return (
    <>
      <div className={styles.sectionHeader}> Agreement Addendums</div>
      <div className={`${styles.sectionDescription} mb-3`}>
        Chronological overview of sales agreement addendums performed in our
        platform.
      </div>
      <div className={styles.verticalStepper}>
        {steps.map((step: AddendumResponse, index: Key) => (
          <div
            key={step.id}
            className={`${styles.step} ${
              index === steps.length - 1 ? styles.lastStep : ''
            }`}
          >
            <div className={styles.outerCircle}>
              <div className={styles.innerCircle} />
            </div>
            <div className={styles.content}>
              <div className={styles.title}>{step.action}</div>
              <div className={styles.description}>
                <span className="me-1">{step.data.modifiedDate}</span>
              </div>
              {step.data.changes.map((v) => (
                <div className={styles.description}>{v}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default Timeline;
